import { Box, Tooltip, useTheme } from "@mui/material"
import { FaRobot } from "react-icons/fa" 
import * as default_data from '../../config.js'

export const DeepAgentToggle = ({ mode, handleChatMode, paid }) => {
  const theme = useTheme()

  const toggleDeepAgent = () => {    
    if (mode === 'deep_agent') {
      handleChatMode('chat')  
    }
    else {
      handleChatMode('deep_agent')
    }
  }

  if (default_data.default_block_deep_agent === true) {
    return null
  }

  return (
    <Tooltip
      title={'Deep Agent'}
      placement="top"
      arrow
      enterDelay={500}
      leaveDelay={200}
    >
      <Box
        onClick={toggleDeepAgent}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          borderRadius: 4,
          p: 0.5,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        }}
      >
        <FaRobot
          size={22}
          color={
            mode === 'deep_agent'
              ? theme.palette.primary.dark
              : theme.palette.text.secondary
          }
        />
      </Box>
    </Tooltip>
  )
}
